import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
import { KTSVG } from "../../../smallnation/helpers"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import {  useLocation, useHistory } from "react-router-dom";
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';

//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const CreateEducation: FC = () => {
      const intl = useIntl();
      let history = useHistory();
      const red="red";
      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all",mode: "onBlur" 
      });

      const submitValue = () => {
        var validateEditorTxt = 1;
        if($('#education_title').val() == ""){
          $("#educationNameValidMsg").show();  
          $(window).scrollTop($('#educationNameValidMsg').position().top);
          validateEditorTxt = 0;     
        }else{
          $("#educationNameValidMsg").hide();  
        }

        if(validateEditorTxt == 0){
          return false;
         }

        const requestObject={
            "name":$("#education_title").val(),
        }
        console.log(requestObject);
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };

        services.adminAddEducation(requestOptions).then((res) => 
        {
          if (res.code == '200') {
            $("#addeducationsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#addeducationsuccessMessage").slideUp(500);
            });
            setTimeout(() => {
              history.push('/educationlist');
            }, 1000);
          }
          else {
            $("#addeducationfailMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#addeducationfailMessage").slideUp(500);
            });
            setTimeout(() => {
              
            }, 1000);
          }
         
        });
        
      }
     
      useEffect(() => 
      {       
       $('#educationNameValidMsg').hide();
       $('#addeducationsuccessMessage').hide();
       $('#addeducationfailMessage').hide();
      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Create Education'})}</PageTitle>
          <form   onSubmit={handleSubmit(submitValue)}>     
             <div className="container">
               <div className="row">
                 

                 <div className="col-lg-12">
                 <div className="mb-4">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">Education Title</label>
                 
                 </div>
                  <input type="text" id="education_title" name="education_title" className="form-control" placeholder=""  />
                           <div id="educationNameValidMsg" style={{color:red}} className="error">Education Title is required.</div>
              </div>
                 </div>
                
                
                 <div className="col-lg-12">
                 <div className="mb-5 px-3">
                 <div className="d-flex flex-column ">
                 <div className="row mt-8">
                    <div className="divider"></div>
                    <button type="submit" className="btn btn-primary mt-2" style={{maxWidth: "200px"}}> Create Education </button>
                 </div>
                 </div>
                 <div id="addeducationsuccessMessage" className="alert alert-success" role="alert">Education Added Successfully</div>
                 <div id="addeducationfailMessage" className="alert alert-danger" role="alert">Please try again</div>
              </div>
                 </div>

               </div>
             </div>
             </form>
        </>
      )
    }
export {CreateEducation}